import { Component } from '@angular/core';

import { BasePageComponent } from '../../shared/base/components/base-page.component';
import { BaseWhiteMessagesIndexComponent } from "../base/base-white-messages-index/base-white-messages-index.component";

@Component({
    selector: 'app-organization-white-messages',
    templateUrl: './organization-white-messages.component.html',
    styleUrls: ['./organization-white-messages.component.scss'],
    imports: [BaseWhiteMessagesIndexComponent]
})

export class OrganizationWhiteMessagesComponent extends BasePageComponent {
  getTableDataApiMethodName: string =
    'whiteMessagesGetOrganizationWhiteMessagesWithPagination';
  pageTitle: string = 'pages.organizationWhiteMessages.title';
}
